<template>
  <page
    :custom-style="{
      backgroundColor: '#fff',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh'
    }"
  >
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="nav-bar"
      left-arrow
      :title="APP_CONFIG.freight_name"
      right-text="运费规则"
      :safe-top-distance="statusBarHeight"
      @click-left="goBack"
      @click-right="goRules"
    />
    <topMsg
      :is-mini-program="isMiniProgram"
      :top-freight-msg="top_freight_msg"
      :selected_company_id="selected_company_id"
    ></topMsg>
    <scroll-view
      v-if="list.length"
      class="list"
      :style="{ height: wrapperHeight }"
      :reach-bottom-loading="reachBottomLoading"
      @loadData="loadData"
    >
      <ul class="shipping-fee-list">
        <li
          v-for="item in list"
          :key="item.order_id"
          :class="{ today: item.today_order }"
          @click="goDetail(item.order_id, item.freight_day)"
        >
          <div class="content" :class="{ ...themeAppColorClass }">
            <div class="content-head">
              <div>
                <span v-if="item.today_order" class="today-peg">今日运费</span>
                {{ item.c_t }}
              </div>
              <div class="opt">
                <span v-if="item.today_order">查看明细</span>
                <IconFont name="mc-icon-arrowright" size="0.24rem" />
              </div>
            </div>
            <div :class="['today-price', 'price']">
              <span class="title">今日下单金额</span>
              <span class="unit">¥</span>
              <span class="value">
                {{ `${item.order_amount || '0'}` }}
              </span>
            </div>
            <div class="fee-detail">
              <div class="fee-detail-item">
                <p class="fee-detail-item-key">应付运费</p>
                <p class="fee-detail-item-value">
                  {{ `¥${item.receive_total_amount || '0'}` }}
                </p>
              </div>
              <div class="fee-detail-item">
                <p class="fee-detail-item-key">已付运费</p>
                <p class="fee-detail-item-value">
                  {{ `¥${item.receive_paid_amount || '0'}` }}
                </p>
              </div>
              <div class="fee-detail-item">
                <p class="fee-detail-item-key">已抵运费券</p>
                <p class="fee-detail-item-value">
                  {{ `¥${item.receive_coupon_paid_amount || '0'}` }}
                </p>
              </div>
              <div class="fee-detail-item">
                <p class="fee-detail-item-key">实付运费</p>
                <p class="fee-detail-item-value">
                  {{ `¥${item.receive_online_paid_amount || '0'}` }}
                </p>
              </div>
            </div>
            <div
              v-if="item.back_amount_msg"
              class="fee-status"
              :class="themeLightBgColor"
            >
              {{ item.back_amount_msg }}
            </div>
          </div>
        </li>
      </ul>
      <div class="history-title">
        <span>可查看近六个月运费</span>
      </div>
    </scroll-view>
    <div v-if="!list.length && !reachBottomLoading" class="empty">
      <img src="@/images/empty/shipping-fee.png" alt="" />
      <p class="text">{{ msg_top }}</p>
      <p class="sub-text">{{ msg_bottom }}</p>
    </div>
  </page>
</template>

<script>
import { API } from '@/api'
import ScrollView from '@/common/widgets/scroll_view/index.vue'
import themeMixin from '@/common/mixins/theme'
import { miniProgramEnv } from '@/defines/environment'
import { APP_CONFIG } from '@/defines/environment/config'
import topMsg from './topMsg.vue'
import { navBar } from '@/utils/native_interactions/native_bar'
import Url from '@mc/mc-utils/js/url/url'
export default {
  components: {
    ScrollView,
    topMsg
  },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.list = []
      const url = new Url(window.location.href)
      const queries = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      // eslint-disable-next-line camelcase
      const selected_company_id =
        queries.selected_company_id || hashQuery.selected_company_id
      // eslint-disable-next-line camelcase
      vm.selected_company_id = selected_company_id || ''

      if (vm.isMiniProgram) {
        navBar.setTitle({
          text: APP_CONFIG.freight_name
        })
      }
      vm.getFreightFeeList({
        page: 1,
        per_page: vm.pageControl.perPage,
        next_freight_day: 0,
        selected_company_id: vm.selected_company_id
      })
    })
  },
  data() {
    return {
      list: [],
      reachBottomLoading: false,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      msg_top: '',
      msg_bottom: '',
      selected_company_id: '',
      pageControl: {
        loading: false,
        finish: false,
        page: 1,
        perPage: 20,
        next_freight_day: 0 // 第一页 传0，非正常 分页，后端 要做 数据聚合
      },
      top_freight_msg: '',
      APP_CONFIG
    }
  },
  computed: {
    wrapperHeight() {
      return `calc(100vh - ${this.pagePaddingTop})`
    }
  },
  methods: {
    loadData() {
      if (this.reachBottomLoading || this.pageControl.finish) return
      return this.getFreightFeeList({
        page: this.pageControl.page,
        per_page: this.pageControl.perPage,
        next_freight_day: this.pageControl.next_freight_day,
        selected_company_id: this.selected_company_id
      })
    },
    goDetail(id, freightDay) {
      this.$router.push({
        name: 'my-shipping-fee-detail',
        query: {
          id,
          freight_day: freightDay
        }
      })
      this.$track(this.$trackMap.freight.freightListDetail, {
        fare_detail_id: id ? String(id) : ''
      })
    },
    goRules() {
      this.$router.push({
        name: 'shipping-fee-rules',
        query: {
          selected_company_id: this.selected_company_id
        }
      })
      this.$track(this.$trackMap.freight.freightListRules)
    },
    goBack() {
      this.$back()
    },
    async getFreightFeeList(props) {
      this.reachBottomLoading = true
      try {
        const data = await API.shippingFee.getFreightFeeList({
          ...props
        })
        if (Array.isArray(data.order_list) && data.order_list.length) {
          this.list = this.list.concat(data.order_list)
          this.pageControl.page += 1
          this.pageControl.next_freight_day = data.next_freight_day
        } else {
          this.pageControl.finish = true
          this.msg_top = data?.msg_top
          this.msg_bottom = data?.msg_bottom
        }
        this.top_freight_msg = data.top_freight_msg || ''
      } catch (error) {
        this.$catch(error)
      }
      this.reachBottomLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background-color: #ffffff;
  .headnav {
    flex: none;
  }
}
.list {
  background-color: #f5f5f5;
}

.history-title {
  display: flex;

  margin: 0 12px;
  padding: 12px 0;

  flex-flow: row nowrap;

  align-items: center;

  &:before {
    display: block;

    height: 1px;

    border-bottom: 1px solid #ececec;

    flex: auto;

    content: '';
  }

  &:after {
    display: block;

    height: 1px;

    border-bottom: 1px solid #ececec;

    flex: auto;

    content: '';
  }

  span {
    display: block;

    padding: 0 12px;

    flex: none;

    font-size: 0.25rem;
    text-align: center;
    color: #ccc;
  }
}

.shipping-fee-list {
  transform: translate3d(0, 0, 0);

  li {
    display: flex;
    flex-flow: row nowrap;

    position: relative;

    margin-top: 0.24rem;
    padding: 0 0.24rem;

    .content {
      overflow: hidden;

      background-color: #fff;

      border-radius: 0.16rem;

      flex: auto;

      color: #262626;

      &-head {
        height: 0.8rem;
        padding: 0.24rem 0.24rem 0.16rem;

        font-size: 0.28rem;
        @include flex-row-between;
        .opt {
          @include flex-row-center-column-normal;
          & > span {
            margin-right: 0.1rem;
          }
          .meicai-icon-right-arrow {
            font-size: 0.24rem;
          }
        }
      }

      .fee-detail {
        padding: 0.12rem 0 0.2rem;
        @include flex-row-between;

        &-item {
          flex: 1;

          text-align: center;

          &-key {
            font-size: 0.24rem;
            color: #8c8c8c;
          }
          &-value {
            margin-top: 0.06rem;

            font-size: 0.3rem;
          }
        }
      }

      .fee-status {
        padding: 0.16rem 0.24rem;

        background-color: rgba(21, 187, 92, 0.15);

        font-size: 0.24rem;
        color: #15bb5c;
      }
    }

    &.today {
      .content {
        background-color: #15bb5c;

        &.small {
          background-color: $theme-main_small;
        }

        &-head,
        .fee-detail-item-value {
          color: #fff;
        }

        .fee-detail-item-key {
          color: rgba(255, 255, 255, 0.8);
        }

        .fee-status {
          background-color: #dcf5e7;
        }
      }
      .today-peg {
        font-size: 0.3rem;
      }
      .today-price {
        color: #fff;
      }
    }
    .price {
      display: flex;

      height: 0.6rem;

      padding-left: 0.24rem;

      align-items: baseline;
      .title {
        margin-right: 0.1rem;

        font-size: 0.24rem;
      }
      .unit {
        font-size: 0.24rem;
      }
      .value {
        font-size: 0.32rem;
      }
    }
  }
}
.empty {
  display: flex;

  padding-top: 23%;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-size: 14px;
  img {
    width: 120px;
  }
  .text,
  .sub-text {
    margin-top: 30px;

    text-overflow: ellipsis;

    overflow: hidden;

    white-space: nowrap;
    color: rgb(153, 153, 153);
  }
  .sub-text {
    margin-top: 20px;
  }
}
.wxmp-nav-right {
  position: fixed;
  top: 0.12rem;
  right: 0.24rem;
  z-index: 1000;

  .nav-action {
    box-sizing: border-box;

    min-width: 0.44rem;

    height: 0.44rem;
    padding: 0 0.1rem;

    background-color: rgba(255, 255, 255, 0.66);

    border-radius: 0.22rem;

    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

    font-size: 0.24rem;
    line-height: 0.44rem;
    text-align: center;
    color: #0daf52;
  }
}
</style>
